import Vue from 'vue'
import Router from 'vue-router'

const Canvas = resolve => require(['@/views/Canvas'], resolve)
const Compress = resolve => require(['@/views/Compress'], resolve)
const Error404 = resolve => require(['@/views/error/Error404'], resolve)

Vue.use(Router)

let routes = [
    { path: '/', component: resolve => require(['@/views/Home'], resolve) },
    { path: '/viewer', component: resolve => require(['@/views/Viewer'], resolve) },
    {
        path: '/canvas',
        component: Canvas
    },
    {
        path: '/compress',
        component: Compress
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js